import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Chip, Grid } from '@mui/material';
import EditFoodItemsInOrder from './EditFoodItemsInOrder';
//import useOrder from '../../Catering/Components/CateringEvent/Components/MenuSelection/useOrder';

function OrderSummaryDisplay(props) {
    const {
        rowId,
        itemsInOrder,
        rowHeight,
        updateOrderSummaryForRow,
        removeItemFromOrderSummaryForRow,
        showEditButton,
        updateTranscriptionTextForRow,
    } = props;
    const [openMenuDialog, setOpenMenuDialog] = useState(false);

    return (
        <>
            {/* popup to edit the order details */}
            {openMenuDialog && (
                <EditFoodItemsInOrder
                    rowId={rowId}
                    openMenuDialog={openMenuDialog}
                    setOpenMenuDialog={setOpenMenuDialog}
                    updateOrderSummaryForRow={updateOrderSummaryForRow}
                    removeItemFromOrderSummaryForRow={
                        removeItemFromOrderSummaryForRow
                    }
                    updateTranscriptionTextForRow={
                        updateTranscriptionTextForRow
                    }
                />
            )}

            {/* grid to display the items in the order */}
            <Grid
                container
                spacing={1}
                direction={'row'}
                alignItems={'center'}
                style={{
                    padding: '5px',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    width: '100%',
                    maxHeight: rowHeight,
                    overflowY: 'auto',
                    overflowX: 'hidden',
                }}
            >
                <Grid item xs={9.5}>
                    <Grid container spacing={1} direction={'row'} rowGap={0.5}>
                        {itemsInOrder &&
                            itemsInOrder.map((item, index) => (
                                <Grid item xs={12} key={index}>
                                    <Chip
                                        label={
                                            <div
                                                style={{
                                                    whiteSpace: 'normal',
                                                    wordBreak: 'break-word',
                                                    width: '100%',
                                                    textAlign: 'center',
                                                }}
                                            >
                                                <div>
                                                    <b>{`${item.quantity} x ${item.name}`}</b>
                                                    {item.choice && (
                                                        <div
                                                            style={{
                                                                marginTop:
                                                                    '2px',
                                                                fontStyle:
                                                                    'italic',
                                                                fontSize:
                                                                    ' 0.9em',
                                                            }}
                                                        >
                                                            {item.choice}
                                                        </div>
                                                    )}
                                                    {item.modifiersStr && (
                                                        <div
                                                            style={{
                                                                marginTop:
                                                                    '2px',
                                                                fontStyle:
                                                                    'italic',
                                                                fontSize:
                                                                    ' 0.9em',
                                                            }}
                                                        >
                                                            {item.modifiersStr}
                                                        </div>
                                                    )}
                                                    {item.notes && (
                                                        <div
                                                            style={{
                                                                marginTop:
                                                                    '2px',
                                                                fontStyle:
                                                                    'italic',
                                                                fontSize:
                                                                    ' 0.9em',
                                                            }}
                                                        >
                                                            {item.notes}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        }
                                        sx={{
                                            height: 'auto',
                                            '& .MuiChip-label': {
                                                whiteSpace: 'normal',
                                                display: 'block',
                                                lineHeight: 1.2,
                                                width: '100%',
                                                textAlign: 'center',
                                                padding: '4px 8px',
                                            },
                                        }}
                                        onDelete={() =>
                                            removeItemFromOrderSummaryForRow(
                                                rowId,
                                                item.key
                                            )
                                        }
                                    />
                                </Grid>
                            ))}
                    </Grid>
                </Grid>
                {showEditButton && (
                    <Grid item xs={2.5}>
                        <button
                            style={{
                                padding: '5px 10px',
                                backgroundColor: '#1976d2',
                                color: '#fff',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer',
                            }}
                            onClick={() => {
                                setOpenMenuDialog(true);
                            }}
                        >
                            Edit
                        </button>
                    </Grid>
                )}
            </Grid>
        </>
    );
}

OrderSummaryDisplay.propTypes = {
    rowId: PropTypes.string.isRequired,
    itemsInOrder: PropTypes.arrayOf(
        PropTypes.shape({
            key: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
            quantity: PropTypes.number.isRequired,
        })
    ).isRequired,
    rowHeight: PropTypes.number,
    updateOrderSummaryForRow: PropTypes.func,
    removeItemFromOrderSummaryForRow: PropTypes.func.isRequired,
    showEditButton: PropTypes.bool,
    updateTranscriptionTextForRow: PropTypes.func,
};

OrderSummaryDisplay.defaultProps = {
    showEditButton: true,
};

export default OrderSummaryDisplay;
